var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"https://v.youku.com/v_show/id_XMzk0NzY1NzM2MA=="}},[_c('span',{staticClass:"video"},[_vm._v("视频地址")])]),_c('img',{attrs:{"src":require("../assets/gantong.jpg"),"alt":"","width":"100%"}})])
}]

export { render, staticRenderFns }